import React, { useEffect, useState } from "react"
import Layout from "../components/Layout"
import useGoogleSheets from "use-google-sheets"

const copy = {
  en: {
    title: "Frequently Asked Questions",
  },
  cn: {
    title: "常見問題",
  },
}

const Faq = ({ lang }) => {
  const translate = key => copy[lang][key]

  const [faq, setFaq] = useState([])
  const { data, loading, error } = useGoogleSheets({
    apiKey: process.env.GATSBY_GOOGLE_SHEETS_API_KEY,
    sheetId: "1zMfbm4SyyhZlbW4sQiTYoG2VM_qNKFD-f7fBE73eprE",
  })

  useEffect(() => {
    if (data && data[0] && data[0].data) {
      setFaq(data[0].data)
    }
  }, [data])

  return (
    <Layout lang={lang}>
      <section className="header">
        <h1 className="header__title">{translate("title")}</h1>
        <p className="header__description"></p>
      </section>
      <section className="faq">
        {loading && <p className="faq__message">Loading questions...</p>}
        {error && (
          <p className="faq__message">
            Could not load questions! Please come back later.
          </p>
        )}
        {faq.map(row => (
          <>
            <strong>{row.Question}</strong>
            <p>{row.Answer}</p>
          </>
        ))}
      </section>
    </Layout>
  )
}

export default Faq
